import { Decimal, Percent, Difference } from "@liquity/lib-base";
import { CollateralLexicon } from "src/lexicon";

type Props = {
  collateral: string
  collateralUSDValue: string
  debt: string
  collateralRatio?: Decimal
  changeCollateral?: Difference
  lexicon?: CollateralLexicon
}

export const TrovePosition = ({ collateral, collateralUSDValue, debt, collateralRatio, changeCollateral, lexicon }: Props) => {
  const collateralRatioPct = new Percent(collateralRatio ?? { toString: () => "N/A" });
  const changePct = changeCollateral && new Percent(changeCollateral);

  return (
    <div className="bg-card border-card flex flex-row flex-wrap py-8 px-5 justify-between">
      <div className="flex flex-col items-center mx-6 md:ml-20 md:order-1">
        <div className="text-style-sub">Your Collateral</div>
        <div className="text-style-value mt-3">{collateral} {lexicon?.term}</div>
        <div className="text-style-sub mt-1">${collateralUSDValue}</div>
      </div>
      {collateralRatioPct && !collateralRatio?.infinite && (
        <div className="md:order-2 md:flex flex-col order-last mx-auto mt-6 md:mt-0">
          {/* temp */}
          <div className="text-style-value">{collateralRatioPct.prettify()}</div>
          {changePct && (
            <div className="text-style-label">{changePct?.nonZeroish(2)?.prettify()}</div>
          )}
        </div>
      )}
      <div className="flex flex-col items-center mx-6 md:mr-20 md:order-3">
        <div className="text-style-sub">Your Debt</div>
        <div className="text-style-value mt-3">{debt} SLSD</div>
        {/* <div className="text-style-sub mt-1">$0.00</div> */}
      </div>
    </div>
  )
}